/**
 * Google Tag Manager (GTM) and Google Analytics 4 (GA4) configuration.
 * Used by layout, analytics lib, and GTM dataLayer.
 *
 * In GTM: for the "Google Tag" tag type, set Tag ID to the GA4 Measurement ID (e.g. G-XXXXXXXXXX),
 * not the GTM container ID. Use "Initialization - All Pages" trigger for site-wide GA4.
 */
export const GOOGLE_TAGS = {
  /** GTM container ID — loaded in root layout. */
  GTM_ID: process.env.NEXT_PUBLIC_GTM_ID || "GTM-PNL4FGM8",
  /** GA4 Measurement ID — used by gtag and by the "Google Tag" in GTM. */
  GA4_ID: process.env.NEXT_PUBLIC_GA4_ID || "G-2HX67538YK",
} as const;
